export default {"src":"/_next/static/media/sql-query.8dfe69a8.svg","height":104,"width":264,"blurWidth":0,"blurHeight":0};